/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { createSlice } from "@reduxjs/toolkit";
import { componentState } from "./component.state";

const componentConfig = createSlice({
    name: "component",

    initialState: componentState,

    reducers: {
        setCategories (state, action) {
            const categories = action?.payload;
            state.categories = categories;
        },

        setByCategory (state, action) {
            const byCategory = action?.payload;
            state.byCategory = byCategory;
        },

        setComponentConfigs (state, action) {
            const components = action?.payload;
            state.components = components;
        },

        setComponentConfigsAll (state, action) {
            const all = action?.payload;
            state.all = all;
        },
        
        setLoading (state, action) {
            state.loading = action.payload;
        },

    },
});

export const componentReducer = componentConfig.reducer;

export const {
    setCategories,
    setComponentConfigs,
    setLoading,
    setByCategory,
    setComponentConfigsAll,
} = componentConfig.actions;
